// Modules
import _ from 'lodash'
import { useCallback } from 'react'
import { LiaEuroSignSolid } from 'react-icons/lia'
import {
  PiBankLight,
  PiBookmarkSimpleDuotone,
  PiChartPieSliceFill,
  PiColumnsFill,
  PiFireFill,
} from 'react-icons/pi'
import { TbCloudFilled } from 'react-icons/tb'
import { useSelector } from 'react-redux'

// Constants
import { CurrencyGroups, FavouriteGroup } from 'constants/currency'

// Store
import {
  titlesAccordionSelector,
  updatedFavouritesSelector,
} from 'store/actions/ComplexSelectors/market-watch-accordion-list-hook'
import { currencyListSelector } from 'store/actions/CurrencySocket/selectors'

function useMarketWatchAccordionList() {
  const list = useSelector(currencyListSelector)

  const titlesAccordion = useSelector(titlesAccordionSelector)
  const updatedFavourites = useSelector(updatedFavouritesSelector)

  const getIconAccordion = useCallback((groupId) => {
    switch (groupId) {
      case FavouriteGroup:
        return PiBookmarkSimpleDuotone
      case CurrencyGroups.forex:
        return LiaEuroSignSolid
      case CurrencyGroups.stocks:
        return PiBankLight
      case CurrencyGroups.indices:
        return PiChartPieSliceFill
      case CurrencyGroups.crypto:
        return TbCloudFilled
      case CurrencyGroups.commodities:
        return PiFireFill
      case CurrencyGroups.metals:
        return PiColumnsFill
      default:
        return PiBankLight
    }
  }, [])

  const getCurrencyCategoryByName = useCallback(
    (currencyName) => getCurrencyCategoryByNameHelper(currencyName, list, titlesAccordion),
    [list, titlesAccordion],
  )

  return { titlesAccordion, getIconAccordion, updatedFavourites, getCurrencyCategoryByName }
}

export default useMarketWatchAccordionList

export const getCurrencyCategoryByNameHelper = (currencyName, list, titlesAccordion) => {
  for (let i = 0; i < titlesAccordion.length; i++) {
    const category = titlesAccordion[i]
    const currency = _.find(list[category], { name: currencyName })
    if (currency) {
      return category
    }
  }
  return null
}
